import { render, staticRenderFns } from "./CMvSwiper.vue?vue&type=template&id=98a1cdc6&"
import script from "./CMvSwiper.vue?vue&type=script&lang=ts&"
export * from "./CMvSwiper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports